import { useApplicationsState } from '@/features/administrator-panel/applications/applicationsState';
import { useCustomersListState } from '@/features/administrator-panel/customer/state';

export const clearAppState = () => {
  // Intentionally not clearing useUserSessionState
  useApplicationsState.getState().clear();
  useCustomersListState.getState().clear();
};
